import React from 'react';
import {Modal, Button} from 'antd';
import './index.less';

interface CommonModalProps {
    titleText?: string;
    modalVisible: boolean;
    handleModalSubmit: () => void;
    handleModalCancel: () => void;
    children?: React.ReactNode;
}
export default function CommonModal(props: CommonModalProps) {
    const {titleText, modalVisible, handleModalSubmit, handleModalCancel} = props;
    return (<Modal
        title=""
        open={modalVisible}
        footer={null}
        centered
        onCancel={handleModalCancel}
        wrapClassName="common-type-modal-wrapper"
        className="common-type-modal"
        maskClosable={false}
        width={460}
        closable={false}
    >
        <div className="">
            <div className="common-type-modal-title">
                {titleText ? titleText : '温馨提示'}
            </div>
            <div className="common-type-modal-text">
                {props.children}
            </div>
            <div className="common-type-modal-btns">
                <Button
                    className="custom-btn cancel-btn"
                    onClick={handleModalCancel}
                >
                    否
                </Button>
                <Button
                    className="custom-btn"
                    type="primary"
                    onClick={handleModalSubmit}
                >
                    是
                </Button>
            </div>
        </div>
    </Modal>);
}